module.exports = __webpack_public_path__ + "static/media/Rentech.0690d478.png";